import { useFeatureFlagEnabled } from '@/app-shell/flags/posthog-compat';

/**
 * Work Home patient/visit workspace. PostHog
 * `release-scribe-enable-work-home-object-workspace`. OFF (default): keep
 * today's Recent Visits / patient-select behaviour. ON: allow mounting the
 * side-by-side patient/visit workspace beside Work chat. Independent kill
 * switch — call sites decide how it combines with Agent Home / Projects.
 *
 * A LEAF under `src/features/flags`, never the barrel: a CODEOWNERS row keeps
 * this path on agents-pod, so PR smoke still selects the agents domain instead
 * of failing open to the full matrix. PostHog cannot move into
 * `packages/agents` `./flags` (ruling 36), so the key stays app-side and the
 * package takes the resolved read as a seam member. Import the leaf — do not
 * add a barrel re-export until that can land without widening E2E scope.
 */
export const WORK_HOME_OBJECT_WORKSPACE_FLAG_KEY =
  'release-scribe-enable-work-home-object-workspace';

export const useIsWorkHomeObjectWorkspaceEnabled = () => {
  return useFeatureFlagEnabled(WORK_HOME_OBJECT_WORKSPACE_FLAG_KEY) ?? false;
};
